(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jewish-wedding-checklist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initChecklist() {
      document.querySelectorAll('[data-wtz-checklist-item]').forEach(function (checkbox) {
        if (checkbox.dataset.checklistInit) return;
        checkbox.dataset.checklistInit = 'true';
        const key = 'wtz-checklist:' + checkbox.id;
        try {
          if (localStorage.getItem(key) === 'true') checkbox.checked = true;
        } catch (e) {
          // ponytail: localStorage can throw in locked-down private browsing; checklist just
          // stops persisting for that visitor, nothing else on the page depends on it.
        }
        checkbox.addEventListener('change', function () {
          try {
            localStorage.setItem(key, checkbox.checked);
          } catch (e) {
            /* see try/catch above */
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initChecklist);
    } else {
      initChecklist();
    }
    document.addEventListener('shopify:section:load', initChecklist);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weitzman-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const mq = window.matchMedia('(min-width: 561px)');

    function initFooterAccordion() {
      const cols = document.querySelectorAll('.wtz-footer__col--accordion');
      if (!cols.length) return;

      cols.forEach(function (col) {
        if (col.dataset.footerAccordionInit) return;
        col.dataset.footerAccordionInit = 'true';
        col.addEventListener('toggle', function () {
          col.dataset.userToggled = 'true';
        });
      });

      sync(mq);
    }

    function sync(e) {
      document.querySelectorAll('.wtz-footer__col--accordion').forEach(function (col) {
        if (e.matches) {
          col.open = true;
        } else if (!col.dataset.userToggled) {
          col.open = false;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFooterAccordion);
    } else {
      initFooterAccordion();
    }
    document.addEventListener('shopify:section:load', initFooterAccordion);
    mq.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weitzman-gift-finder"] && !Shopify.designMode) return;
  try {
    
  function initGiftFinder() {
  document.querySelectorAll('[data-gf-root]').forEach(function (root) {
    if (root.dataset.gfInit) return;
    root.dataset.gfInit = 'true';
    const STEPS = [
      { key: 'occasion', q: 'What is the occasion?', opts: ['Hanukkah', 'Bar or Bat Mitzvah', 'A wedding', 'A new baby', 'Shabbat or a new home', 'Just because'] },
      { key: 'recipient', q: 'Who is it for?', opts: ['The host', 'The newlyweds', 'The little ones', 'The reader', 'A mensch', 'Myself'] },
      { key: 'budget', q: 'And the budget?', opts: ['Under $25', 'Under $50', 'Under $100', '$100 and up'] }
    ];

    // Routing data is emitted by Liquid from the live catalog: only collections
    // that exist and hold products survive into here. If the JSON is ever
    // missing or malformed the quiz degrades to plain search rather than
    // throwing, so the section can never hard-fail the homepage.
    let ROUTES = { occasion: {}, recipient: {}, pair: {} };
    try {
      const node = root.querySelector('[data-gf-routes]');
      if (node) {
        const parsed = JSON.parse(node.textContent);
        ROUTES = {
          occasion: parsed.occasion || {},
          recipient: parsed.recipient || {},
          pair: parsed.pair || {}
        };
      }
    } catch (e) {
      /* fall through to search-only routing */
    }

    // Each budget carries the count field that matches it, so the number the
    // shopper reads is the number of shoppable products in the band they
    // actually picked, not the size of the whole collection.
    const BUDGETS = {
      'Under $25': { filter: 'filter.v.price.lte=25', key: 'n25' },
      'Under $50': { filter: 'filter.v.price.lte=50', key: 'n50' },
      'Under $100': { filter: 'filter.v.price.lte=100', key: 'n100' },
      '$100 and up': { filter: 'filter.v.price.gte=100', key: 'n100up' }
    };

    // How many shoppable products a candidate holds in the chosen band.
    function qualified(cand) {
      if (!cand) return 0;
      const b = BUDGETS[picks.budget];
      const n = b && cand[b.key];
      return typeof n === 'number' ? n : (cand.q || 0);
    }

    const stage = root.querySelector('[data-gf-stage]');
    const prog = root.querySelector('[data-gf-progress]');
    const back = root.querySelector('[data-gf-back]');
    let i = 0;
    let picks = {};

    prog.innerHTML = STEPS.map(function () { return '<i></i>'; }).join('');

    function paintProg() {
      const dots = prog.children;
      for (let k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k <= i);
    }

    // An answer is only offered as a live route if Liquid resolved at least one
    // real collection for it. Everything else falls back to search.
    // Option labels may carry a non-breaking space to prevent an orphan word
    // (see the Bar or Bat Mitzvah label). The Liquid routing keys use plain
    // spaces, so every lookup normalises before matching, or the pair route
    // silently misses and the answer falls back to a less specific collection.
    function keyOf(label) {
      return String(label).replace(/\u00a0/g, ' ');
    }

    // A result page needs enough on it to feel like a choice. Landing a shopper
    // on 2 products reads as broken even though the page is technically valid,
    // so a candidate has to clear MIN_DEPTH in the chosen budget to win on
    // specificity. Below that we keep walking to a broader collection, and only
    // if nothing clears it do we take the richest option available.
    const MIN_DEPTH = 8;

    function best(side, key) {
      const entry = ROUTES[side] && ROUTES[side][keyOf(key)];
      if (!entry || !entry.c || !entry.c.length) return null;
      for (let k = 0; k < entry.c.length; k++) {
        if (qualified(entry.c[k]) >= MIN_DEPTH) return entry.c[k];
      }
      const ranked = entry.c.slice().sort(function (a, b) { return qualified(b) - qualified(a); });
      return qualified(ranked[0]) > 0 ? ranked[0] : null;
    }

    function termFor(side, key) {
      const entry = ROUTES[side] && ROUTES[side][keyOf(key)];
      return (entry && entry.term) || '';
    }

    // Every destination carries the three answers as one gf parameter. Shopify
    // Analytics reports landing pages with their query string, so after a few
    // weeks of traffic this says which collection each answer combination
    // actually converts on. That is what lets the candidate order below be
    // reordered from measured behaviour instead of an editorial guess.
    // ponytail: a URL parameter, not an analytics SDK. Ceiling: it reports
    // clicks and sessions, not revenue per answer. Upgrade path: join it
    // against a "Product sales by product" export once one exists.
    function gfTag() {
      const slug = function (v) {
        return String(v).replace(/\u00a0/g, ' ').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      };
      return 'gf=' + slug(picks.occasion) + '_' + slug(picks.recipient) + '_' + slug(picks.budget);
    }

    function destUrl(cand, budgetQuery) {
      const params = [];
      if (budgetQuery) params.push(budgetQuery);
      params.push(gfTag());
      return '/collections/' + cand.h + '?' + params.join('&');
    }

    // Other collections that also clear the depth bar for these answers, so the
    // shopper can steer instead of taking the one route we picked. Deduped,
    // richest first, and capped so the card stays a decision rather than a list.
    function alternates(chosen, pair) {
      const pool = [];
      if (pair) pool.push(pair);
      const oc = ROUTES.occasion[keyOf(picks.occasion)];
      const rc = ROUTES.recipient[keyOf(picks.recipient)];
      if (oc && oc.c) pool.push.apply(pool, oc.c);
      if (rc && rc.c) pool.push.apply(pool, rc.c);

      // Rank on relevance, not raw size. Sorting by count alone floats the
      // broad catch-alls (Gift Ideas, Home Decor) above the collections that
      // actually match the answers, which is the opposite of useful. Keep the
      // pool order, which is already most-specific first (pair, then occasion,
      // then recipient), and only use depth to break ties within a tier.
      const seen = {};
      if (chosen) seen[chosen.h] = true;
      const out = [];
      for (let k = 0; k < pool.length; k++) {
        const c = pool[k];
        if (!c || seen[c.h]) continue;
        seen[c.h] = true;
        if (qualified(c) >= MIN_DEPTH) out.push({ c: c, rank: k });
      }
      return out.sort(function (a, b) {
        return a.rank - b.rank;
      }).slice(0, 3).map(function (x) { return x.c; });
    }

    function routing() {
      const budget = BUDGETS[picks.budget];
      const budgetQuery = budget && budget.filter;
      const pair = ROUTES.pair[keyOf(picks.occasion) + '|' + keyOf(picks.recipient)];
      const isJustBecause = (picks.occasion === 'Just because');

      let target = null;
      let reason = '';

      // A pair is the most specific answer, but only if it actually holds
      // something in this budget. An empty pair falls through to the broader
      // occasion rather than sending the shopper to a page with nothing on it.
      if (pair && qualified(pair) >= MIN_DEPTH) {
        target = pair;
        reason = picks.occasion + ' picks for ' + picks.recipient.toLowerCase();
      } else if (isJustBecause) {
        target = best('recipient', picks.recipient);
        reason = 'Gifts for ' + picks.recipient.toLowerCase();
      } else {
        target = best('occasion', picks.occasion) || best('recipient', picks.recipient);
        if (!target && pair) { target = pair; }
        reason = target ? picks.occasion + ' picks' : 'Gift picks';
      }

      if (target) {
        return {
          url: destUrl(target, budgetQuery),
          reason: reason,
          count: qualified(target),
          label: target.t,
          alts: alternates(target, pair)
        };
      }

      // No verified collection for this path: degrade to native search, which
      // also matches title, body, vendor and type, so it cannot zero-result
      // the way a stale collection or tag link silently does.
      const term = termFor('occasion', picks.occasion) || termFor('recipient', picks.recipient) || 'gift';
      const params = ['type=product', 'options[prefix]=last'];
      if (budgetQuery) params.push(budgetQuery);
      params.push(gfTag());
      return {
        url: '/search?q=' + encodeURIComponent(term) + '&' + params.join('&'),
        reason: reason || 'Gift picks',
        count: 0,
        label: '',
        alts: []
      };
    }

    function focusStage() {
      const heading = stage.querySelector('.wtz-gf__q');
      if (!heading) return;
      heading.setAttribute('tabindex', '-1');
      heading.focus();
    }

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function render(opts) {
      paintProg();
      back.hidden = (i === 0);
      if (i < STEPS.length) {
        const s = STEPS[i];
        stage.innerHTML = '<p class="wtz-gf__q">' + s.q + '</p><div class="wtz-gf__opts">' + s.opts.map(function (o) {
          return '<button type="button" class="wtz-gf__opt' + (picks[s.key] === o ? ' is-sel' : '') + '" data-v="' + esc(o) + '" aria-pressed="' + (picks[s.key] === o) + '">' + esc(o) + '</button>';
        }).join('') + '</div>';

        Array.prototype.forEach.call(stage.querySelectorAll('[data-v]'), function (btn) {
          btn.addEventListener('click', function () {
            picks[s.key] = btn.getAttribute('data-v');
            i++;
            render({ moved: true });
          });
        });
      } else {
        const route = routing();
        // Only claim a count when Liquid actually resolved one, so the number
        // on screen is always the real live collection size.
        // The number is a floor of in-stock, fully merchandised products inside
        // the chosen budget, so it is always honourable. No count is printed
        // when nothing could be verified, rather than a guessed one.
        const note = route.count
          ? '<p class="wtz-gf__note">' + route.count + (route.count === 1 ? ' piece' : ' pieces') + ' in ' + esc(route.label) + '</p>'
          : '';
        // Offer the other collections that also clear the bar for these answers.
        // The quiz makes a recommendation, it does not trap the shopper in it,
        // and every count shown is the same verified in-band figure.
        const alts = (route.alts || []).length
          ? '<div class="wtz-gf__alts"><p class="wtz-gf__alts-label">Or browse</p><ul class="wtz-gf__alts-list">' +
            route.alts.map(function (a) {
              return '<li><a href="' + destUrl(a, (BUDGETS[picks.budget] || {}).filter) + '">' +
                esc(a.t) + ' <span>' + qualified(a) + '</span></a></li>';
            }).join('') + '</ul></div>'
          : '';

        stage.innerHTML = '<div class="wtz-gf__result"><p class="wtz-gf__q">' + esc(route.reason) + '</p>' +
          '<div class="wtz-gf__sum"><span>' + esc(picks.occasion) + '</span><span>' + esc(picks.recipient) + '</span><span>' + esc(picks.budget) + '</span></div>' +
          note +
          '<a class="wtz-gf__cta" href="' + route.url + '">See the&nbsp;gifts ' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>' +
          alts +
          '<button type="button" class="wtz-gf__restart" data-gf-restart>Start over</button></div>';

        stage.querySelector('[data-gf-restart]').addEventListener('click', function () {
          i = 0;
          picks = {};
          render({ moved: true });
        });
      }
      if (opts && opts.moved) focusStage();
    }

    back.addEventListener('click', function () {
      if (i > 0) { i--; render({ moved: true }); }
    });

    render();
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftFinder);
  } else {
    initGiftFinder();
  }
  document.addEventListener('shopify:section:load', initGiftFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weitzman-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader() {
    document.querySelectorAll('[data-mobile-search-toggle]').forEach(function (toggle) {
      if (toggle.dataset.mobileSearchInit) return;
      toggle.dataset.mobileSearchInit = 'true';
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      toggle.addEventListener('click', function () {
        const open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          const input = panel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    });
    document.querySelectorAll('[data-wtz-burger]').forEach(function (burger) {
      if (burger.dataset.burgerInit) return;
      burger.dataset.burgerInit = 'true';
      const header = burger.closest('.wtz-header');
      const nav = header && header.querySelector('#wtz-main-nav');
      if (!nav) return;
      let navLastFocus = null;
      function trapNavFocus(e) {
        const focusables = nav.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      burger.addEventListener('click', function () {
        const open = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          navLastFocus = document.activeElement;
          const firstLink = nav.querySelector('a, button');
          if (firstLink) firstLink.focus();
        } else if (navLastFocus) {
          navLastFocus.focus();
          navLastFocus = null;
        }
      });
      nav.addEventListener('keydown', function (e) {
        if (!window.matchMedia('(max-width: 960px)').matches || !nav.classList.contains('is-open')) return;
        if (e.key === 'Escape') {
          nav.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
          burger.focus();
          navLastFocus = null;
        } else if (e.key === 'Tab') {
          trapNavFocus(e);
        }
      });
      nav.querySelectorAll('.wtz-has-mega > .wtz-nav-link').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (!window.matchMedia('(max-width: 960px)').matches) return;
          const item = link.closest('.wtz-nav-item');
          if (item && !item.classList.contains('is-open')) {
            e.preventDefault();
            nav.querySelectorAll('.wtz-nav-item.is-open').forEach(function (openItem) {
              if (openItem !== item) openItem.classList.remove('is-open');
            });
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
    document.querySelectorAll('.wtz-header .wtz-has-mega').forEach(function (item) {
      if (item.dataset.megaFocusInit) return;
      item.dataset.megaFocusInit = 'true';
      const trigger = item.querySelector(':scope > .wtz-nav-link');
      if (trigger) {
        item.addEventListener('focusin', function () {
          if (window.matchMedia('(max-width: 960px)').matches) return;
          trigger.setAttribute('aria-expanded', 'true');
        });
        item.addEventListener('focusout', function (e) {
          if (window.matchMedia('(max-width: 960px)').matches) return;
          if (!item.contains(e.relatedTarget)) trigger.setAttribute('aria-expanded', 'false');
        });
      }
    });
    document.querySelectorAll('.wtz-header .wtz-has-mega').forEach(function (item) {
      if (item.dataset.megaPreviewInit) return;
      item.dataset.megaPreviewInit = 'true';
      const previews = item.querySelector('.wtz-mega-previews');
      if (!previews) return;
      const defaultHTML = previews.innerHTML;
      const shopLabel = previews.getAttribute('data-shop-label') || 'Shop';
      let swapTimer = null;
      function buildCard(prod, fallbackHref) {
        const card = document.createElement('a');
        card.className = 'wtz-mega-preview-card';
        card.href = prod.url || fallbackHref || '#';
        if (prod.img) {
          const img = document.createElement('img');
          img.src = prod.img;
          img.alt = prod.title || '';
          img.width = 150;
          img.height = 100;
          img.loading = 'lazy';
          card.appendChild(img);
        }
        const body = document.createElement('div');
        body.className = 'wtz-mega-preview-body';
        const title = document.createElement('h5');
        title.textContent = prod.title || '';
        const desc = document.createElement('p');
        desc.textContent = prod.desc || '';
        const cta = document.createElement('span');
        cta.textContent = (prod.price ? prod.price + ' • ' : '') + shopLabel + ' →';
        body.appendChild(title);
        body.appendChild(desc);
        body.appendChild(cta);
        card.appendChild(body);
        return card;
      }
      function swapTo(build) {
        previews.style.opacity = '0';
        clearTimeout(swapTimer);
        swapTimer = setTimeout(function () {
          build();
          previews.style.opacity = '1';
        }, 100);
      }
      item.querySelectorAll('.wtz-mega-links a[data-products]').forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          let products;
          try {
            products = JSON.parse(link.getAttribute('data-products'));
          } catch (err) {
            return;
          }
          if (!products || !products.length) return;
          swapTo(function () {
            previews.innerHTML = '';
            products.forEach(function (prod) {
              previews.appendChild(buildCard(prod, link.href));
            });
          });
        });
      });
      item.addEventListener('mouseleave', function () {
        swapTo(function () {
          previews.innerHTML = defaultHTML;
        });
      });
    });
    /* A picked category with NO typed term navigates straight to that
       pillar's real hub collection (option.value is already that
       collection's URL) -- picking a category with nothing typed means
       "browse this department," so it lands shoppers on the hub's own
       real, compounding filters.

       A picked category WITH a typed term means "I'm already searching,
       keep me in results, scoped to this department" -- it must NOT
       redirect to the hub, or a shopper mid-search gets yanked away from
       what they're doing. Scopes via Shopify's real tag:"x" OR tag:"y"
       search syntax (confirmed live: OR-combining multiple tag: clauses
       narrows results correctly, e.g. "cup tag:\"judaica\" OR tag:
       \"hanukkah\"..." returns fewer/different results than an unscoped
       search).

       data-search-tags on each option is a pipe-separated tag list, ONE
       PER CATEGORY, hand-verified live against the Shopify Admin API
       (never guessed) -- see 408-tags-master-developer-spec.csv in
       clients/weitzman/deliverables/collections-taxonomy-master-2026-09-01/
       for the source taxonomy. This catalog is mid-migration from an
       older flat tag vocabulary (judaica, hanukkah, jewelry, babies...)
       to a newer namespaced one (category:x, holiday:x, artist:x...),
       and the two are NOT interchangeable per category -- each was
       checked individually:
         - Gift Ideas, Apparel: collection's live ruleSet is ALREADY on
           the new namespaced tags. Copied verbatim.
         - Jewelry, Books: collection's ruleSet is still on the old flat
           tags, but a clean, fully-adopted new tag also exists
           (category:jewelry; category:books-media + category:paper-goods)
           -- OR'd in alongside the flat ones so nothing that only
           carries the new tag gets missed.
         - Judaica: same idea, OR'd with the 5 real holiday:* tags that
           are actually live (holiday:hanukkah/passover/purim/
           rosh-hashanah/shabbat). Several MORE granular holiday:* tags
           appear in the taxonomy CSV (holiday:hanukkah-menorahs, etc.)
           but do not exist on any live product yet -- confirmed via
           direct query, not included.
         - Baby/Kids: the new tag (recipient:babies-kids) is checked and
           found nearly unpopulated live (5 products vs. 351 on the flat
           "babies" tag) -- switching to it would silently break this
           category, so it's intentionally NOT included; flat tag only.
         - Ketubah: no collection ruleSet at all (manually curated) and
           no namespaced tag exists for it live either. The flat tag
           "show-all-ketubah" is the closest available proxy, not a
           perfect match to the curated list.
       Re-verify against the live catalog before changing any of these;
       this taxonomy is actively migrating and today's snapshot will go
       stale. There's no way to derive it automatically from the
       storefront at Liquid render time. */
    document.querySelectorAll('[data-wtz-search]').forEach(function (form) {
      if (form.dataset.wtzSearchWired === '1') return;
      form.dataset.wtzSearchWired = '1';
      form.addEventListener('submit', function (e) {
        const cat = form.querySelector('[name="category"]');
        if (!cat || !cat.value) return;
        const qInput = form.querySelector('[name="q"]');
        const term = qInput ? qInput.value.trim() : '';
        const opt = cat.options[cat.selectedIndex];
        const tagsRaw = opt && opt.dataset.searchTags;
        if (term && tagsRaw) {
          /* Never overwrite qInput.value in place: that's the same live,
             visible box the predictive-search dropdown is reading from
             (confirmed live -- the qualified string flashed into the
             search box and its typeahead dropdown before/around
             navigation, exposing internal query syntax the shopper never
             typed). Submitting a same-named hidden input placed right
             after qInput sends the qualified value as "q" instead
             (a form only submits one value per name; the later element in
             DOM order wins), while qInput itself, and everything reading
             it live, keeps showing only what the shopper actually typed. */
          e.preventDefault();
          const tags = tagsRaw.split('|');
          const scope = tags.map(function (t) { return 'tag:"' + t + '"'; }).join(' OR ');
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'q';
          hidden.value = term + ' (' + scope + ')';
          qInput.insertAdjacentElement('afterend', hidden);
          qInput.removeAttribute('name');
          form.submit();
          return;
        }
        e.preventDefault();
        window.location.href = cat.value;
      });
    });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeader);
    } else {
      initHeader();
    }
    document.addEventListener('shopify:section:load', initHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weitzman-hero-slider"] && !Shopify.designMode) return;
  try {
    
  function initHeroSlider() {
  document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
    if (root.dataset.heroSliderInit) return;
    root.dataset.heroSliderInit = 'true';
    const track = root.querySelector('[data-hero-track]');
    const slides = Array.prototype.slice.call(root.querySelectorAll('.wtz-hero-slide'));
    if (slides.length < 2) return;

    const dots = Array.prototype.slice.call(root.querySelectorAll('.wtz-slider-dot'));
    const prevBtn = root.querySelector('[data-hero-prev]');
    const nextBtn = root.querySelector('[data-hero-next]');
    let current = 0;
    let timer = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        const cta = slide.querySelector('.wtz-hero-slide-cta');
        if (cta) cta.tabIndex = active ? 0 : -1;
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
      if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }

    function start() {
      if (reduceMotion) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, 7000);
    }
    function stop() {
      if (timer) clearInterval(timer);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); start(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) start();
    });

    show(0);
    start();
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSlider);
  } else {
    initHeroSlider();
  }
  document.addEventListener('shopify:section:load', initHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weitzman-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductCarousel() {
      document.querySelectorAll('.wtz-prod-carousel [data-wtz-carousel]').forEach(function (wrap) {
        if (wrap.dataset.prodCarouselInit) return;
        wrap.dataset.prodCarouselInit = 'true';
        const track = wrap.querySelector('[data-carousel-track]');
        const prev = wrap.querySelector('[data-carousel-prev]');
        const next = wrap.querySelector('[data-carousel-next]');
        if (!track) return;
        const step = function () {
          const card = track.querySelector('.wtz-prod-carousel__card');
          return card ? card.offsetWidth + 24 : 300;
        };
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductCarousel);
    } else {
      initProductCarousel();
    }
    document.addEventListener('shopify:section:load', initProductCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weitzman-promo-overlay"]) return;
  try {
    
  function initPromoOverlay() {
  (function () {
    document.querySelectorAll('[data-promo-overlay]').forEach(function (overlay) {
      if (overlay.dataset.promoOverlayInit) return;
      overlay.dataset.promoOverlayInit = 'true';
      const storageKey = overlay.dataset.storageKey;
      if (!storageKey) return;
      try {
        const storedExpiry = parseInt(localStorage.getItem(storageKey), 10);
        if (storedExpiry && Date.now() < storedExpiry) return;
        /* Someone who already subscribed has answered the ask this overlay
           competes with, so don't interrupt them again. The flag is set by
           the newsletter form's own success state; nothing here ever
           un-suppresses the overlay. */
        if (localStorage.getItem('wtz_newsletter_signed_up') === '1') return;
      } catch (e) { /* private-browsing: fall through and show it once */ }

      /* The overlay opens on a timer, so it takes focus from wherever the
         visitor happened to be. Without restoring it, dismissing the popup
         drops focus to <body> and a keyboard user has to tab from the top
         of the page to get back to what they were doing. */
      var promoLastFocus = null;

      function close() {
        overlay.hidden = true;
        document.body.classList.remove('wtz-promo-overlay-open');
        if (promoLastFocus && typeof promoLastFocus.focus === 'function') promoLastFocus.focus();
        promoLastFocus = null;
      }

      overlay.querySelectorAll('[data-promo-overlay-close]').forEach(function (btn) {
        btn.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (overlay.hidden) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'Tab' && window.WTZ && window.WTZ.trapFocus) {
          window.WTZ.trapFocus(overlay.querySelector('.wtz-promo-overlay__box'), e);
        }
      });

      const deadline = overlay.dataset.deadline;
      let countdownInterval;
      function startCountdown() {
        const target = new Date(deadline.replace(' ', 'T')).getTime();
        if (isNaN(target)) return;
        const el = overlay.querySelector('[data-promo-countdown]');
        if (!el) return;
        const daysEl = el.querySelector('[data-countdown-days]');
        const hoursEl = el.querySelector('[data-countdown-hours]');
        const minutesEl = el.querySelector('[data-countdown-minutes]');
        const secondsEl = el.querySelector('[data-countdown-seconds]');
        function pad(n) { return String(n).length === 1 ? '0' + n : String(n); }
        function tick() {
          const diff = target - Date.now();
          if (diff <= 0) {
            clearInterval(countdownInterval);
            el.hidden = true;
            return;
          }
          const totalSeconds = Math.floor(diff / 1000);
          daysEl.textContent = pad(Math.floor(totalSeconds / 86400));
          hoursEl.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
          minutesEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
          secondsEl.textContent = pad(totalSeconds % 60);
        }
        tick();
        countdownInterval = setInterval(tick, 1000);
      }

      const delaySeconds = parseInt(overlay.dataset.delaySeconds, 10) || 4;
      let suppressDays = parseInt(overlay.dataset.suppressDays, 10);
      if (isNaN(suppressDays)) suppressDays = 1;
      setTimeout(function () {
        try {
          const expiresAt = Date.now() + suppressDays * 24 * 60 * 60 * 1000;
          localStorage.setItem(storageKey, String(expiresAt));
        } catch (e) { /* ignore */ }
        promoLastFocus = document.activeElement;
        overlay.hidden = false;
        document.body.classList.add('wtz-promo-overlay-open');
        const closeBtn = overlay.querySelector('[data-promo-overlay-close].wtz-promo-overlay__close');
        if (closeBtn) closeBtn.focus();
        if (deadline) startCountdown();
      }, delaySeconds * 1000);
    });
  })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoOverlay);
  } else {
    initPromoOverlay();
  }
  document.addEventListener('shopify:section:load', initPromoOverlay);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weitzman-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFallbackCarousel() {
      document.querySelectorAll('.wtz-testimonials__carousel-wrap').forEach(function (wrap) {
        const track = wrap.querySelector('[data-carousel-track]');
        const prev = wrap.querySelector('[data-carousel-prev]');
        const next = wrap.querySelector('[data-carousel-next]');
        if (!track || wrap.dataset.carouselInit) return;
        wrap.dataset.carouselInit = 'true';

        const getStep = function () {
          const item = track.querySelector('.wtz-testimonial-card');
          return item ? item.offsetWidth + 20 : 320;
        };

        if (prev) {
          prev.addEventListener('click', function (e) {
            e.preventDefault();
            track.scrollBy({ left: -getStep(), behavior: 'smooth' });
          });
        }
        if (next) {
          next.addEventListener('click', function (e) {
            e.preventDefault();
            track.scrollBy({ left: getStep(), behavior: 'smooth' });
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFallbackCarousel);
    } else {
      initFallbackCarousel();
    }
    document.addEventListener('shopify:section:load', initFallbackCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
